import styled from 'styled-components';
import {customScrollBarStyle} from "../utils/getKeyframes";
// import { createGlobalStyle } from 'styled-components';

interface WrapperProps {
    withoutMaxWidth?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
    padding: 0 30px;
    max-width: ${({ withoutMaxWidth }: WrapperProps) => withoutMaxWidth
        ? `unset`
        : `1300px`
    }
`;

export const Main = styled.div<{
    isMacOS?: boolean;
}>`
    .main_modal {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        height: 180px;
    }
    .modal_title {
        font-size: 16px;
        font-weight: bold;
    }
    .modal_body {
        font-size: 16px;
    }
    .icon_notification {
        background: red;
        color: red;
        width: 20px;
        height: 5px;
    }
    .modal_data {
        margin: 10px;
    }

    ${({isMacOS}) => customScrollBarStyle(isMacOS!)}
`;